// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file responses/v1/package_provider_features_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/package_provider_features_response.proto.
 */
export const file_responses_v1_package_provider_features_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CjVyZXNwb25zZXMvdjEvcGFja2FnZV9wcm92aWRlcl9mZWF0dXJlc19yZXNwb25zZS5wcm90bxIMcmVzcG9uc2VzLnYxInYKH1BhY2thZ2VQcm92aWRlckZlYXR1cmVzUmVzcG9uc2USGwoTcGFja2FnZV9wcm92aWRlcl9pZBgBIAEoBBI2CghmZWF0dXJlcxgCIAMoDjIkLnJlc3BvbnNlcy52MS5QYWNrYWdlUHJvdmlkZXJGZWF0dXJlKkgKFlBhY2thZ2VQcm92aWRlckZlYXR1cmUSEgoOUEFDS0FHRV9QT0lOVFMQABIJCgVMQUJFTBABEg8KC0NPTUlOR19TT09OEAJCjwEKEGNvbS5yZXNwb25zZXMudjFCJFBhY2thZ2VQcm92aWRlckZlYXR1cmVzUmVzcG9uc2VQcm90b1ABWgQuL3BiogIDUlhYqgIMUmVzcG9uc2VzLlYxygIMUmVzcG9uc2VzXFYx4gIYUmVzcG9uc2VzXFYxXEdQQk1ldGFkYXRh6gINUmVzcG9uc2VzOjpWMWIGcHJvdG8z'
    );

/**
 * @generated from message responses.v1.PackageProviderFeaturesResponse
 */
export type PackageProviderFeaturesResponse = Message<'responses.v1.PackageProviderFeaturesResponse'> & {
    /**
     * @generated from field: uint64 package_provider_id = 1;
     */
    packageProviderId: bigint;

    /**
     * @generated from field: repeated responses.v1.PackageProviderFeature features = 2;
     */
    features: PackageProviderFeature[];
};

/**
 * Describes the message responses.v1.PackageProviderFeaturesResponse.
 * Use `create(PackageProviderFeaturesResponseSchema)` to create a new message.
 */
export const PackageProviderFeaturesResponseSchema: GenMessage<PackageProviderFeaturesResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_package_provider_features_response, 0);

/**
 * @generated from enum responses.v1.PackageProviderFeature
 */
export enum PackageProviderFeature {
    /**
     * @generated from enum value: PACKAGE_POINTS = 0;
     */
    PACKAGE_POINTS = 0,

    /**
     * @generated from enum value: LABEL = 1;
     */
    LABEL = 1,

    /**
     * @generated from enum value: COMING_SOON = 2;
     */
    COMING_SOON = 2,
}

/**
 * Describes the enum responses.v1.PackageProviderFeature.
 */
export const PackageProviderFeatureSchema: GenEnum<PackageProviderFeature> =
    /*@__PURE__*/
    enumDesc(file_responses_v1_package_provider_features_response, 0);
